<div class="row row-cols-1 row-cols-xl-2">
    <div class="col" *ngFor="let ledgerDataArray of ledgerDataMap | keyvalue; let i=index">
        <div class="card radius-10 mb-3">
            <div class="card-body">
                <div class="d-flex align-items-center mb-3">
                    <div>
                        <h5 class="mb-1 capitailized"><strong>{{ ledgerDataArray.value[0]?.account.name }}</strong></h5>
                        <p class="mb-0 font-13 capitailized colour">{{
                            ledgerDataArray.value[0]?.account.type }}</p>

                    </div>
                    <div class="font-22 ms-auto"></div>
                    <div class="widgets-icons ms-auto"
                        [ngClass]="{'green-color': ledgerDataArray.value[0]?.account?.normal === 'credit', 'red-color': ledgerDataArray.value[0]?.account?.normal === 'debit'}">
                        <i class='bx bxs-wallet'></i>
                    </div>
                </div>
                <div class="product-list p-3 mb-3" [perfectScrollbar]>
                    <div class="row border mx-0 mb-3 py-2 radius-10 cursor-pointer"
                        *ngFor="let ledger of ledgerDataArray.value" (click)="onRowClick(ledger)">
                        <div class="col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="ms-2">
                                    <p class="mb-0"><i class='bx bxs-info-circle text-primary me-1'></i>{{
                                        ledger.reference }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm d-flex" *ngIf="ledger.account?.normal === 'debit'">
                            <div class="mb-1 me-3">&#8377;{{ ledger.debitAmount }}</div>
                        </div>
                        <div class="col-sm d-flex" *ngIf="ledger.account?.normal === 'credit'">
                            <div class="mb-1 me-3">&#8377;{{ ledger.debitAmount }}</div>
                        </div>
                        <div class="col-sm product-img">
                            <p class="mb-0 font-13 text-secondary">{{ ledger.date }}</p>
                        </div>
                    </div>
                    <div class="ms-2">
                        <h6 class="mb-1 total"
                            *ngIf="calculateTotalDebit(ledgerDataArray.value) > 0 && ledgerDataArray.value[0]?.account?.normal !== 'credit'">
                            Total: <strong>&#8377;{{ calculateTotalDebit(ledgerDataArray.value) }}</strong>
                        </h6>

                        <!-- Display Total Credit only when it's greater than 0 -->
                        <ng-container *ngIf="calculateTotalDebit(ledgerDataArray.value) > 0 && ledgerDataArray.value[0]?.account?.normal !== 'debit'">
                            <h6 class="mb-1 total">
                                Total: <strong>&#8377;{{ calculateTotalDebit(ledgerDataArray.value) }}</strong>
                            </h6>
                        </ng-container>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>
<!-- Shimmer Effect Placeholder -->
<div class="col" *ngIf="(ledgerDataMap | keyvalue).length === 0">
    <div class="card radius-10 mb-3">
        <div class="card-body">
            <div class="shimmer-wrapper mb-3"></div>
            <div class="shimmer-wrapper mb-3"></div>
            <div class="shimmer-wrapper mb-3"></div>
        </div>
    </div>
</div>
